module.exports = __webpack_public_path__ + "static/media/blue-right.a63549a7.png";